import qs from "query-string";
import { RouteComponentProps } from "react-router-dom";

type History = RouteComponentProps["history"];

// @eslint-ignore
export const parseRouteParams = <T>(search: string): T => (search ? (qs.parse(search) as unknown as T) : ({} as T));

export const createRouteSearch = (params: object): string => "?" + qs.stringify(params);

export const updateRouteParams = (history: History, pathname: string, params: object, state: object): void => {
  const search = createRouteSearch(params);

  history.push({
    pathname,
    search,
    state,
  });
};

export const urlReplace = (str: string, data: object): string => {
  if (!str) {
    return "";
  }
  Object.entries(data).forEach(([key, value]) => (str = str.replace(`:${key}`, value)));
  return str;
};
